module.exports = __webpack_public_path__ + "img/Visualisierung blau1-klein.435ad074.jpg";